module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "When_the_Fun_Stops_Stop.53d4ccd5.webp";